import {
  useQuery,
  UseQueryResult,
} from "@tanstack/react-query";
import { PostOrgV2 } from "../api";

type Projection = {
  [key: string]: number;
};

type PostOrgProps = {
  open?: boolean;
  authToken: string;
  projection?: Projection;
};

export const usePostOrg = ({
  open = false,
  authToken,
  projection,
}: PostOrgProps): UseQueryResult => {
  const finalProjection = {
    projection: projection,
  };
  const enabled = !!authToken && open === true;
  return useQuery({
    queryKey: ["PostOrgV2", finalProjection],
    queryFn: () => PostOrgV2(authToken, finalProjection),
    enabled: enabled,
    staleTime: 0,
    notifyOnChangeProps: "all",
  });
};
